<template>
    <div id="share_box" class="share-box">
        <div class="share-top">
            <img src="@/assets/images/share/top-bgc2.png" alt="">
        </div>
        <div class="base-info" v-show="objResult.city">
            <div class="title">{{ objResult.city }} ｜ {{ objResult.project_name2 }}</div>
            <div class="info">
                <div class="info-item">
                    <img src="@/assets/images/share/rl.png" alt="">
                    <span>{{ objResult.date ? objResult.date.split(' ')[0] : '' }}</span>
                </div>
                <div v-if="objResult.house_cate" class="info-item">
                    <img src="@/assets/images/share/bs.png" alt="">
                    <span>{{ objResult.house_cate || '' }}</span>
                </div>
                <div v-if="objResult.house_area" class="info-item">
                    <img src="@/assets/images/share/mj.png" alt="">
                    <span>{{ objResult.house_area || 120 }}㎡</span>
                </div>
            </div>
        </div>
        <div class="eva-test" v-show="objResult.city">
            <div class="content">{{ objResult.poster_title || '“很满意史密斯这次的服务，采暖、空调效果也非常好”' }}</div>
            <div class="after">—— {{ objResult.city }}用户 {{ objResult.name }}</div>
        </div>
        <!--评价详情-->
        <!-- 竣工评价 -->
        <div class="eva-item" v-if="objResult.discuss?.jungong?.id">
            <div class="top-info">
                <div class="man-wrap">
                    <div class="head-img"><img src="@/assets/images/share/head.png" alt=""></div>
                    <div class="name">{{ objResult.name }}</div>
                </div>
                <div class="eva-info">
                    <div class="tag-wrap">
                        <div class="tag">项目验收与使用评价</div>
                        <div class="date">{{ objResult.discuss.jungong.created_at.split(' ')[0] }}</div>
                    </div>
                    <div v-if="objResult.discuss.jungong.content" class="test-eva">{{
                            objResult.discuss.jungong.content || ''
                        }}
                    </div>
                </div>
            </div>
            <!-- <div class="swiper" v-if="objResult.discuss.jungong?.pic?.length">
                <van-swipe class="my-swipe" :show-indicators="false" @change="onChangeSwipe($event,'nJungongSwipe')">
                    <template v-for="(item,index) in objResult.discuss.jungong.pic">
                        <van-swipe-item class="swiper-item" @click="priviewImg('jgVideo',index)">
                            <template v-if="item.type == 'image'">
                                <img :src="item.pic" alt="">
                            </template>
                            <template v-else>
                                <video :src="item.pic"
                                       :poster="item.pic+ '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'"></video>
                                <img src="@/assets/images/play_icon_2.png" alt="" class="play-icon">
                            </template>
                        </van-swipe-item>
                    </template>
                </van-swipe>
            </div>-->
            <div class="img-wrap" v-if="objResult.discuss.jungong?.pic?.length">
                <template v-for="(item,index) in objResult.discuss.jungong.pic">
                    <!-- <div :class="['img-item',{'img-item-act':nJungongSwipe == index}]"
                             @click="priviewImg('jgImg',index)">-->
                    <div class="img-item" @click="priviewImg('jgImg',index)">
                        <template v-if="item.type == 'image'">
                            <img :src="item.pic" alt="">
                        </template>
                        <template v-else>
                            <video :src="item.pic"
                                   :poster="item.pic+ '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'"></video>
                            <img src="@/assets/images/play_icon_2.png" alt="" class="play-icon">
                        </template>
                    </div>
                </template>
            </div>
            <div class="video-wrap" v-if="objResult.discuss?.jungong.voice"
                 @click="playVideo(objResult.discuss?.jungong.voice, 'jg')">
                <span>{{ objResult.discuss?.jungong.voice_time || '' }}s</span>
                <div class="voice-icon">
                    <img :src="require('@/assets/images/share/video2.png')"/>
                    <img class="icon1" :src="require('@/assets/images/share/voice-icon1.png')"/>
                    <div ref="jgVideoRef" class="mengceng" style="display: none"></div>
                </div>
                <!-- <img src="@/assets/images/share/video2.png" alt=""> -->
            </div>
            <div class="acceptance" v-if="objResult?.reportJg?.length && !objResult.discuss?.jungong.content2"
                 @click="toDetail('jg')">
                <div class="title-wrap">
                    <div class="text">项目验收详情</div>
                    <img src="@/assets/images/share/jt.png" alt="">
                </div>
                <div class="img-box">
                    <div class="img-wrap">
                        <template v-for="(item, index) in objResult.reportJg[0].attach">
                            <div class="img-item2" v-if="index <= 3">
                                <img :src="item" alt="">
                            </div>
                        </template>
                    </div>
                    <div class="ac-icon">
                        <img src="@/assets/images/share/ys.png" alt="">
                    </div>
                </div>
            </div>
            <!--追评-->
            <template v-if="objResult.discuss?.jungong.content2">
                <div class="line-wrap"></div>
                <div class="top-info">
                    <div class="man-wrap">
                        <div class="head-img"><img src="@/assets/images/share/head.png" alt=""></div>
                        <div class="name">{{ objResult.name }}</div>
                    </div>
                    <div class="eva-info">
                        <div class="tag-wrap">
                            <div class="tag">追评</div>
                            <div class="date">{{ objResult.discuss.jungong?.zhui_time?.split(' ')[0] || '' }}</div>
                        </div>
                        <div v-if="objResult.discuss?.jungong.content2" class="test-eva">{{
                                objResult.discuss?.jungong.content2 || ''
                            }}
                        </div>
                    </div>
                </div>
                <!--                <div class="swiper" v-if="objResult.discuss.jungong.picVideoZhui?.length">
                                    <van-swipe class="my-swipe" :show-indicators="false">
                                        <template v-for="(item,index) in objResult.discuss.jungong.picVideoZhui">
                                            <van-swipe-item class="swiper-item" @click="priviewImg( 'jgVideoZhui',index)">
                                                <video :src="item.pic"
                                                       :poster="item.pic+ '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'"></video>
                                                <img src="@/assets/images/play_icon_2.png" alt="" class="play-icon">
                                            </van-swipe-item>
                                        </template>
                                    </van-swipe>
                                </div>
                                <div class="img-wrap" v-if="objResult.discuss.jungong.picImageZhui?.length">
                                    <template v-for="(item,index) in objResult.discuss.jungong.picImageZhui">
                                        <div class="img-item" @click="priviewImg( 'jgImgZhui',index)">
                                            <img :src="item.pic" alt="">
                                        </div>
                                    </template>
                                </div>-->

                <!--  <div class="swiper" v-if="objResult.discuss.jungong?.pic_zhui?.length">
                    <van-swipe class="my-swipe" :show-indicators="false"
                               @change="onChangeSwipe($event,'nJungongZhuiSwipe')">
                        <template v-for="(item,index) in objResult.discuss.jungong.pic_zhui">
                            <van-swipe-item class="swiper-item" @click="priviewImg('jgVideoZhui',index)">
                                <template v-if="item.type == 'image'">
                                    <img :src="item.pic" alt="">
                                </template>
                                <template v-else>
                                    <video :src="item.pic"
                                           :poster="item.pic+ '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'"></video>
                                    <img src="@/assets/images/play_icon_2.png" alt="" class="play-icon">
                                </template>
                            </van-swipe-item>
                        </template>
                    </van-swipe>
                </div>-->

                <div class="img-wrap" v-if="objResult.discuss.jungong?.pic_zhui?.length">
                    <template v-for="(item,index) in objResult.discuss.jungong.pic_zhui">
                        <!-- <div :class="['img-item',{'img-item-act':nJungongZhuiSwipe == index}]"
                                 @click="priviewImg('jgImgZhui',index)">-->
                        <div class="img-item" @click="priviewImg('jgImgZhui',index)">
                            <template v-if="item.type == 'image'">
                                <img :src="item.pic" alt="">
                            </template>
                            <template v-else>
                                <video :src="item.pic"
                                       :poster="item.pic+ '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'"></video>
                                <img src="@/assets/images/play_icon_2.png" alt="" class="play-icon">
                            </template>
                        </div>
                    </template>
                </div>

                <div class="acceptance" v-if="objResult?.reportJg?.length" @click="toDetail('jg')">
                    <div class="title-wrap">
                        <div class="text">项目验收详情</div>
                        <img src="@/assets/images/share/jt.png" alt="">
                    </div>
                    <div class="img-box">
                        <div class="img-wrap">
                            <template v-for="(item, index) in objResult.reportJg[0].attach">
                                <div class="img-item2" v-if="index <= 3">
                                    <img :src="item" alt="">
                                </div>
                            </template>
                        </div>
                        <div class="ac-icon">
                            <img src="@/assets/images/share/ys.png" alt="">
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <!-- 施工评价 -->
        <div class="eva-item" v-if="objResult.discuss?.shigong?.id">
            <div class="top-info">
                <div class="man-wrap">
                    <div class="head-img"><img src="@/assets/images/share/head.png" alt=""></img></div>
                    <div class="name">{{ objResult.name }}</div>
                </div>
                <div class="eva-info">
                    <div class="tag-wrap">
                        <div class="tag">系统施工评价</div>
                        <div class="date">{{ objResult.discuss.shigong.created_at.split(' ')[0] }}</div>
                    </div>
                    <div class="test-eva">
                        {{ objResult.discuss.shigong.content || '' }}
                    </div>
                </div>
            </div>
            <!--            <div v-if="objResult.discuss?.shigong?.id && objResult.discuss.shigong.picVideo?.length" class="swiper">
                            <van-swipe class="my-swipe" :show-indicators="false">
                                <template v-for="(item,index) in objResult.discuss.shigong.picVideo">
                                    <van-swipe-item class="swiper-item" @click="priviewImg('sgVideo',index)">
                                        <video :src="item.pic"
                                               :poster="item.pic+ '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'"></video>
                                        <img src="@/assets/images/play_icon_2.png" alt="" class="play-icon">
                                    </van-swipe-item>
                                </template>
                            </van-swipe>
                        </div>
                        <div class="img-wrap" v-if="objResult.discuss.shigong.picImage?.length">
                            <template v-for="(item,index) in objResult.discuss.shigong.picImage">
                                <div class="img-item" @click="priviewImg('sgImg',index)">
                                    <img :src="item.pic" alt="">
                                </div>
                            </template>
                        </div>-->


            <!-- <div class="swiper" v-if="objResult.discuss?.shigong?.id && objResult.discuss.shigong?.pic?.length">
                <van-swipe class="my-swipe" :show-indicators="false" @change="onChangeSwipe($event,'nShigongSwipe')">
                    <template v-for="(item,index) in objResult.discuss.shigong.pic">
                        <van-swipe-item class="swiper-item" @click="priviewImg('sgVideo',index)">
                            <template v-if="item.type == 'image'">
                                <img :src="item.pic" alt="">
                            </template>
                            <template v-else>
                                <video :src="item.pic"
                                       :poster="item.pic+ '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'"></video>
                                <img src="@/assets/images/play_icon_2.png" alt="" class="play-icon">
                            </template>
                        </van-swipe-item>
                    </template>
                </van-swipe>
            </div>-->
            <div class="img-wrap" v-if="objResult.discuss.shigong?.pic?.length">
                <template v-for="(item,index) in objResult.discuss.shigong.pic">
                    <!-- <div :class="['img-item',{'img-item-act':nShigongSwipe == index}]"
                            @click="priviewImg('sgImg',index)">-->
                    <div class="img-item" @click="priviewImg('sgImg',index)">
                        <template v-if="item.type == 'image'">
                            <img :src="item.pic" alt="">
                        </template>
                        <template v-else>
                            <video :src="item.pic"
                                   :poster="item.pic+ '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'"></video>
                            <img src="@/assets/images/play_icon_2.png" alt="" class="play-icon">
                        </template>
                    </div>
                </template>
            </div>


            <div class="video-wrap" v-if="objResult.discuss?.shigong.voice"
                 @click="playVideo(objResult.discuss?.shigong.voice, 'sg')">
                <span>{{ objResult.discuss?.shigong.voice_time || '' }}s</span>
                <div class="voice-icon">
                    <img :src="require('@/assets/images/share/video2.png')"/>
                    <img class="icon1" :src="require('@/assets/images/share/voice-icon1.png')"/>
                    <div ref="sgVideoRef" class="mengceng" style="display: none"></div>
                </div>
                <!-- <img src="@/assets/images/share/video2.png" alt=""> -->
            </div>
            <div class="acceptance" v-if="objResult?.reportSg?.length" @click="toDetail('sg')">
                <div class="title-wrap">
                    <div class="text">系统施工详情</div>
                    <img src="@/assets/images/share/jt.png" alt="">
                </div>
                <div class="img-box">
                    <div class="img-wrap">
                        <template v-for="(item, index) in objResult.reportSg[0].attach">
                            <div class="img-item2" v-if="index <= 3">
                                <img :src="item" alt="">
                            </div>
                        </template>
                    </div>
                    <div class="ac-icon">
                        <img src="@/assets/images/share/ys.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <!--案例详情-->
        <div class="topic-wrap">
            <div class="topic-title">
                <div class="line"></div>
                <div class="title-topic">案例详情</div>
                <div class="line"></div>
            </div>
            <div class="topic-item" v-if="objResult.url" @click="toShow3d">
                <div class="item-title">3D图纸</div>
                <div class="d-wrap">
                    <div class="d-img">
                        <img src="@/assets/images/share/3D.png" alt="">
                    </div>
                    <div class="btn">
                        <span>点击查看</span>
                        <img src="@/assets/images/share/jt.png" alt="">
                    </div>
                </div>
            </div>
            <div class="topic-item" v-if="objResult.service_lists?.length">
                <div class="item-title">服务团队</div>
                <div class="team-wrap">
                    <div class="team-item" v-for="item in objResult.service_lists">
                        <div class="head-img-team">
                            <img :src="item.icon || ''" alt="">
                        </div>
                        <div class="info-box-team">
                            <div class="top-info">
                                <div class="info-it name">{{ handleName(item.name || '') }}</div>
                                <div class="info-right">
                                    <div class="info-it" v-if="item.job_number">工号：{{ item.job_number || '' }}</div>
                                    <div class="info-it info-it-num" v-if="item.num">项目经验：{{ item.num || 0 }}户</div>
                                    <div v-else class="info-it info-it-num"></div>
                                </div>
                            </div>
                            <div class="b-info">{{ item.rel_group_name }}：{{ item.desc }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 了解更多-->
        <div class="topic-wrap topic-wrap-m">
            <div class="topic-title">
                <div class="line"></div>
                <div class="title-topic">了解更多</div>
                <div class="line"></div>
            </div>
            <div class="product-wrap" @click="toxcx">
                <div class="left-wrap">
                    <img src="@/assets/images/share/sp.png" alt="">
                    <div class="sp-text">
                        A.O.史密斯 AI-LiNK<br/>好风好水 智慧集成
                    </div>
                </div>
                <div class="right">
                    <img src="@/assets/images/share/jt2.png" alt="">
                </div>
                <div class="lj-wrap">
                    <img src="@/assets/images/share/lj.png" alt="">
                    <span>产品详情</span>
                </div>
            </div>
            <div class="more-wrap">
                <div class="more-item" @click="toAntMapHome">
                    <div class="more-left">
                        <img src="@/assets/images/share/al.png" alt="">
                        <span>更多案例</span>
                    </div>
                    <img src="@/assets/images/share/jt2.png" alt="">
                </div>
                <div class="more-item" @click="toEvaList">
                    <div class="more-left">
                        <img src="@/assets/images/share/pj.png" alt="">
                        <span>更多评价</span>
                    </div>
                    <img src="@/assets/images/share/jt2.png" alt="">
                </div>
            </div>
        </div>
        <div :class="['people-wrap',{'people-wrap-m':imgShow}]">
            <div class="left">
                <div class="head"><img :src="objResult.headimgurl || ''" alt=""></div>
                <div class="name">{{ objResult.nickname }}</div>
                <div class="tag">高级服务顾问</div>
            </div>
            <div class="right">
                <img :src="objResult.qrcode || ''" alt="">
                <!-- <img class="mask_img" :src="objResult.qrcode || ''" alt="">-->
            </div>
        </div>

        <div v-if="isShowQrCode" class="code_box" @click="showQrCode">
            <div class="code_plan" @click.stop="()=>{}">
                <img :src="objResult.qrcode || ''" alt="">
            </div>
        </div>
        <div class="page-b">
            <div class="b-left">
                <img src="@/assets/images/share/logo.png" alt="">
                <div class="txt">好风好水 就找A.O.史密斯</div>
            </div>
            <div class="b-right">
                <img src="@/assets/images/share/sp2.png" alt="">
            </div>
        </div>
        <!-- <audio ref="evaVideo"  :src="sEvaVideo"></audio> -->
        <!-- 预览图片 -->
        <!--        <van-image-preview v-model="imgShow" :closeable="true" :startPosition="lookImgIndex"  :images="arrStausImg"></van-image-preview>-->
        <!-- 自定义预览图片-->
        <div class="swipe-box" v-if="imgShow">
            <van-swipe @change="swipeChaneg" :initial-swipe="lookImgIndex">
                <van-swipe-item v-for="(item, index) in arrStausImg" :key="index">
                    <div class="swipe-image" v-if="item.type == 'image'"><img :src="item.pic"/></div>
                    <div v-if="item.type == 'video'" class="meng-img">
                        <video id="videoUrl" controls
                               :poster="item.pic+ '?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,ar_auto'"
                               :src="item.pic"/>
                    </div>
                </van-swipe-item>
            </van-swipe>
            <div class="directive">{{ lookImgIndex + 1 }}/{{ arrStausImg.length }}</div>
            <div class="swipe-close" @click="imgShow = false">
                <img :src="require('@/assets/images/antV2/icon_close.png')"/>
            </div>
        </div>
    </div>
</template>
<script>
import {getQrcodeUrl} from "@/js/member/mynews/index.js";
import {getEvaluationInfo, getEvaPoster, readNum, shareNum} from '@/js/project/share.js'
import oStorage from '@/libsV2/storage.js'
import URLAPI from "@/libsV2/urlApi";
import {v2tov3id} from "@/js/project/evaluation";

export default {
    name: 'ShareDetail_useKP',
    data() {
        return {
            imgShow: false,//预览弹框
            arrStausImg: [],//预览数组
            lookImgIndex: 0,//预览索引
            sEvaVideo: null,
            objResult: {},//详情
            sVideoType: '',
            qrcodeUrl: '',
            keepScroll: 0, //页面滚动位置
            nJungongSwipe: 0,
            nJungongZhuiSwipe: 0,
            nShigongSwipe: 0,
            nLogId: 0, // 上次记录
            tCensus: '', // 统计时间使用的定时器
            nShigongZhuiSwipe: 0,
            isShowQrCode: false,
        }
    },
    created() {
        //23-5-31 项目3.0上线，详情老版本重定向到3.0
        //分享的路径转化成3.0的链接参数
        //老版本是通过project_uuid查询数据，3.0是通过3.0的项目id查询数据，通过接口转化
        let query = '';
        v2tov3id({
            project_id: this.$route.query.acc_id
        }).then((res) => {
            let id = res.data.data.result.project_id;
            if (this.$route.query.track_action) {
                query = `?mode=2&id=${id}&ut_source=${this.$route.query.ut_source}` +
                    `&project_uuid=${this.$route.query.acc_id}&shareId=${this.$route.query.share_id}` +
                    `&track_action=project_share_discuss&track_id=${id}&track_uuid=${this.$route.query.track_uuid}`
            } else {
                query = `?id=${id}&mode=1&ut_source=${this.$route.query.ut_source}`
            }
            this.$router.replace({
                path: `/project/v3/case/details${query}`,
            });
        })
        return;

        $init(() => {
            if (this.$route.query.share_id) {
                this.$store.commit('SAVE_SHARE_USER_ID', {share_user_id: this.$route.query.share_id})
            }
            this.sEvaVideo = new Audio();//用于音频播放
            this.getInfo()//用于获取评价信息
            if (this.$route.query.sfrom) {
                console.log(this.$route.query.sfrom, 'this.$route.query.sfrom')
                shareNum({
                    project_uuid: this.$route.query.acc_id,
                    sfrom: this.$route.query.sfrom,
                    from_id: this.$route.query.from_id,
                    zhuanfa_type: 'haibao'
                }).then()
            }
        })
    },

    activated() {
        console.log(this.keepScroll, 'ces')
        if (this.keepScroll > 0) {
            setTimeout(() => {
                let el = document.getElementById('share_box')
                el.scrollTop = this.keepScroll;
            }, 10);
        }
        // 如果上次统计还在
        if (this.nLogId && !this.tCensus) {
            this.addReadNum(this.$route.query.project_uuid, 'url', 'dis_pic').then(res => {
                this.tCensus = setInterval(() => {
                    // this.$toast('统计')

                    this.addReadNum(this.$route.query.project_uuid, 'url', 'dis_pic', res)
                }, 5000)
            })
        }
    },
    beforeRouteLeave(to, from, next) {
        clearInterval(this.tCensus)
        this.tCensus = ''
        console.log('清楚')
        setTimeout(() => {
            next()
        }, 100)
    },
    methods: {
        // 统计转发数据

        // 统计阅读量
        addReadNum(uuid, type, notice_type, log_id) {
            return new Promise(resolve => {
                //todo 正式先不上统计
                let options = {
                    project_uuid: uuid,
                    type: type,
                    notice_type,
                    share_user_id: this.$route.query.share_id
                }
                if (log_id) {
                    options.log_id = log_id
                }
                readNum(options, false).then(res => {
                    // this.$toast(this.$route.query.share_id)
                    resolve(res.data.result)
                })
            })
        },
        playVideo2() {
            let video = document.getElementById('videoUrl');
            console.log(video);
            if (video.paused) {
                video.play();
                document.getElementById('mantle').style.display = 'none'
                document.getElementById('video-img').style.display = 'none'
            } else {
                video.pause();
                document.getElementById('mantle').style.display = 'block'
                document.getElementById('video-img').style.display = 'block'
            }
            video.addEventListener('ended', function () {
                document.getElementById('mantle').style.display = 'block'
                document.getElementById('video-img').style.display = 'block'
            });
        },
        swipeChaneg(e) {
            this.lookImgIndex = e
        },
        // 调转小程序产品中心
        toxcx() {

            // console.log(this.qrcodeUrl)
            window.location.href = this.qrcodeUrl;

            // this.$store.commit('loadSwitch', true)
            // // 统计产品中心阅读量
            // this.addReadNum(this.$route.query.project_uuid, 'product','info').then(result => {
            //     this.$store.commit('loadSwitch', false)
            //     window.location.href = this.qrcodeUrl;
            // })
        },
        // 获取产品中心链接
        getxcxUrl() {
            // let data = {
            //     page: `productc/pagesv2/goods_detail/index`,//正式参数id=73&itemid=930&name=1980,测试参数type=package&id=136
            //     // param: JSON.stringify({id:73,itemid:930,name:1980}),
            //     // param: JSON.stringify({type:'package',id:136}),
            //     param: process.env.VUE_APP_FLAG == 'production' ? 'id=73&itemid=930&name=1980' : 'type=package&id=136',
            //     type: 2,
            // }
            // getQrcodeUrl(data).then(res => {
            //     let qrcodeUrl = res.data.data.result.url;
            //     this.qrcodeUrl = qrcodeUrl;
            //     console.log(this.qrcodeUrl, '链接')
            //     // window.location.href = qrcodeUrl;
            // })

            // let param = process.env.VUE_APP_FLAG == 'production' ? 'id=73&itemid=930&name=1980' : 'type=package&id=136';
            // this.qrcodeUrl = `${URLAPI.URL5}comm/scan/jumpurl?path=goods&params=${encodeURIComponent(param)}`
            let param = process.env.VUE_APP_FLAG == 'production' ? `id=73&itemid=930&name=1980&project_uuid=${this.$route.query.project_uuid}&share_user_id=${this.$store.state.shareUserId}` : `type=package&id=136&project_uuid=${this.$route.query.project_uuid}&share_user_id=${this.$store.state.shareUserId}`;
            this.qrcodeUrl = `${URLAPI.URL5}comm/scan/jumpurl?path=goods&params=${encodeURIComponent(param)}`

        },
        // 预览图片
        priviewImg(type, index) {
            let arr = []
            this.lookImgIndex = index;

            switch (type) {
                case 'jgVideo':
                case 'jgImg' :
                    arr = this.objResult.discuss.jungong.pic;
                    break;
                case 'jgVideoZhui':
                case 'jgImgZhui' :
                    arr = this.objResult.discuss.jungong.pic_zhui;
                    break;
                case 'sgVideo':
                case 'sgImg' :
                    arr = this.objResult.discuss.shigong.pic;
                    break;
            }

            // if (type == 'jgVideo') {
            //
            //      arr = [...this.objResult.discuss.jungong.picVideo, ...this.objResult.discuss.jungong.picImage]
            //     this.lookImgIndex = index;
            // } else if (type == 'jgImg') {
            //     arr = [...this.objResult.discuss.jungong.picVideo, ...this.objResult.discuss.jungong.picImage]
            //     this.lookImgIndex = this.objResult.discuss.jungong.picVideo.length + index;
            // } else if (type == 'jgVideoZhui') {
            //     arr = [...this.objResult.discuss.jungong.picVideoZhui, ...this.objResult.discuss.jungong.picImageZhui]
            //     this.lookImgIndex = index;
            // } else if (type == 'jgImgZhui') {
            //     arr = [...this.objResult.discuss.jungong.picVideoZhui, ...this.objResult.discuss.jungong.picImageZhui]
            //     this.lookImgIndex = this.objResult.discuss.jungong.picVideoZhui.length + index;
            // } else if (type == 'sgVideo') {
            //     arr = [...this.objResult.discuss.shigong.picVideo, ...this.objResult.discuss.shigong.picImage]
            //     this.lookImgIndex = index;
            // } else if (type == 'sgImg') {
            //     arr = [...this.objResult.discuss.shigong.picVideo, ...this.objResult.discuss.shigong.picImage]
            //     this.lookImgIndex = this.objResult.discuss.shigong.picVideo.length + index;
            // }
            this.imgShow = true;
            let imgArr = []
            arr.forEach(it => {
                imgArr.push({pic: it.pic, type: it.type})
            })
            this.arrStausImg = imgArr;
            console.log(imgArr)
        },
        // 前往项目案例列表
        toAntMapHome() {
            let el = document.getElementById('share_box')
            this.keepScroll = el.scrollTop;
            // this.$store.commit('loadSwitch', true)
            oStorage.setStorage('project_uuid', this.$route.query.project_uuid)
            // 更多案例点击统计
            // this.addReadNum(this.$route.query.project_uuid, 'case','dis_more').then(result => {
            //     this.$store.commit('loadSwitch', false)
            this.$router.push(`/antMap/index?isShareInfo=true&project_uuid=${this.$route.query.project_uuid}`)
            // window.location.replace(`${window.location.origin}/antMap/index`)
            // })
        },
        // 前往评价列表
        toEvaList() {
            let el = document.getElementById('share_box')
            this.keepScroll = el.scrollTop;
            oStorage.setStorage('project_uuid', this.$route.query.project_uuid)
            this.$router.push(`/project/detail/assess?acc_id=b13802aa-691e-ac6d-0000-0633f674b76a&isShareInfo=true&ut_source=ai_heating&project_uuid=${this.$route.query.project_uuid}`)
            // 统计更多评价点击量
            // this.$store.commit('loadSwitch', true)
            // 统计产品中心阅读量
            // this.addReadNum(this.$route.query.project_uuid, 'more_discuss','anli_more').then(result => {
            //     this.$store.commit('loadSwitch', false)
            // window.location.replace(`${window.location.origin}/project/detail/assess?acc_id=b13802aa-691e-ac6d-0000-0633f674b76a`)
            // })
        },
        // 播放语音
        playVideo(url, type) {
            if (!this.sVideoType) {
                this.sVideoType = type
                this.sEvaVideo.src = url;
                this.sEvaVideo.play()
                if (type == 'jg') {
                    this.$refs.jgVideoRef.style.display = 'block'
                } else {
                    this.$refs.sgVideoRef.style.display = 'block'
                }
            } else {
                if (this.sVideoType == type) {
                    if (this.sEvaVideo.duration > 0 && !this.sEvaVideo.paused) {
                        this.sEvaVideo.pause()
                        if (type == 'jg') {
                            this.$refs.jgVideoRef.style.display = 'none'
                        } else {
                            this.$refs.sgVideoRef.style.display = 'none'
                        }
                        return
                    }
                    this.sEvaVideo.src = url;
                    this.sEvaVideo.play()
                    if (type == 'jg') {
                        this.$refs.jgVideoRef.style.display = 'block'
                    } else {
                        this.$refs.sgVideoRef.style.display = 'block'
                    }
                } else {
                    this.sEvaVideo.src = url;
                    this.sEvaVideo.play()
                    if (type == 'jg') {
                        this.$refs.jgVideoRef.style.display = 'block'
                    } else {
                        this.$refs.sgVideoRef.style.display = 'block'
                    }
                }
                this.sVideoType = type
            }
            let that = this
            this.sEvaVideo.addEventListener('ended', function () {
                that.$refs.jgVideoRef.style.display = 'none'
                that.$refs.sgVideoRef.style.display = 'none'
            });

        },
        // 交付详情
        toDetail(type) {
            let arrId = []
            if (type == 'sg') {
                this.objResult.reportSg.forEach(it => {
                    arrId.push(it.rule_report_id)
                })
            } else if (type == 'jg') {
                this.objResult.reportJg.forEach(it => {
                    arrId.push(it.rule_report_id)
                })
            }
            let el = document.getElementById('share_box')
            this.keepScroll = el.scrollTop;
            this.$router.push(`/project/share/report?id=${arrId.join(',')}&project_uuid=${this.$route.query.project_uuid}`)
        },
        // 查看3D
        toShow3d() {
            window.location.href = this.objResult.url + '&noinfo=true';
        },
        // 获取详情信息
        getInfo() {
            this.$store.commit("loadSwitch", true);
            getEvaluationInfo({
                project_uuid: this.$route.query.project_uuid,
                share_user_id: this.$route.query.share_id,
            }).then(res => {
                this.getxcxUrl()//用户获取产品中心小程序链接
                // 进入首先统计进入页面的次数
                this.addReadNum(this.$route.query.project_uuid, 'url', 'dis_pic').then(res => {
                    this.nLogId = res
                    this.tCensus = setInterval(() => {
                        console.log('统计数据')
                        // this.$toast('统计')
                        this.addReadNum(this.$route.query.project_uuid, 'url', 'dis_pic', res)
                    }, 5000)
                })
                this.$store.commit("loadSwitch", false);
                this.objResult = res.data.result
                // 分开视频和图片
                // if (this.objResult.discuss?.jungong?.id) {
                //     let pic = this.objResult.discuss.jungong.pic || []
                //     let pic_zhui = this.objResult.discuss.jungong.pic_zhui || []
                //     this.objResult.discuss.jungong.picVideo = pic.filter(it => {
                //         return it.type == 'video'
                //     })
                //     this.objResult.discuss.jungong.picImage = pic.filter(it => {
                //         return it.type == 'image'
                //     })
                //     this.objResult.discuss.jungong.picVideoZhui = pic_zhui.filter(it => {
                //         return it.type == 'video'
                //     })
                //     this.objResult.discuss.jungong.picImageZhui = pic_zhui.filter(it => {
                //         return it.type == 'image'
                //     })
                // }
                // if (this.objResult.discuss?.shigong?.id) {
                //     let pic = this.objResult.discuss.shigong.pic
                //     this.objResult.discuss.shigong.picVideo = pic.filter(it => {
                //         return it.type == 'video'
                //     })
                //     this.objResult.discuss.shigong.picImage = pic.filter(it => {
                //         return it.type == 'image'
                //     })
                // }

                //视频图片重新排序
                if (this.objResult.discuss?.jungong?.id) {
                    let pic = this.objResult.discuss.jungong.pic || [];
                    let pic_zhui = this.objResult.discuss.jungong.pic_zhui || [];

                    pic.sort((a, b) => {
                        return a.type == 'video' && b.type == 'image' ? -1 : 0;
                    })

                    pic_zhui.sort(function (a, b) {
                        return a.type == 'video' && b.type == 'image' ? -1 : 0;
                    })
                    this.objResult.discuss.jungong.pic = pic;
                    this.objResult.discuss.jungong.pic_zhui = pic_zhui;
                }

                if (this.objResult.discuss?.shigong?.id) {
                    let pic = this.objResult.discuss.shigong.pic || [];
                    pic.sort((a, b) => {
                        return a.type == 'video' && b.type == 'image' ? -1 : 0;
                    })

                    this.objResult.discuss.shigong.pic = pic;
                }

                // 区分施工和竣工
                if (this.objResult?.report?.length) {
                    let arr = this.objResult.report
                    this.objResult.reportSg = arr.filter(it => {
                        return it.title != '系统竣工调试监理报告'
                    })
                    this.objResult.reportJg = arr.filter(it => {
                        return it.title == '系统竣工调试监理报告'
                    })
                }
                console.log(this.objResult, '信息')
            })
        },
        // 获取基本信息
        getBaseInfo() {
            getEvaPoster({
                project_uuid: 'b13802aa-691e-ac6d-0000-0633f674b76a',
                project_id: '452'
            }).then(res => {
                this.objBaseInfo = res.data.result
                console.log(res, '信息2')
            })
        },
        onChangeSwipe(e, key) {
            this[key] = e;
        },
        showQrCode() {
            this.isShowQrCode = !this.isShowQrCode;
        },
        handleName(name) {
            return `${name.slice(0, 1) + '*'}${name.length >= 3 ? name.slice(-1) : ''}`;
        }
    },
}
</script>
<style lang="scss" scoped>
.swipe-box {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.85);

    .swipe-close {
        position: absolute;
        top: 28px;
        right: 28px;

        img {
            width: 38px;
            height: 38px;
        }
    }

    .directive {
        position: absolute;
        top: 28px;
        left: 50%;
        // z-index: 1200;
        transform: translate(-50%);
        color: #fff;
        font-size: 28px;
        padding: 4px 18px;
        background: rgba(0, 0, 0, 0.6);
        border-radius: 2px;
    }

    .swipe-image {
        position: relative;
        // position: absolute;
        width: 100vw;
        height: 100vh;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    .meng-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;

        video {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }

        .video-img {
            position: absolute;
            left: 0;
            top: 0;
            z-index: 1;

            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }

        .video_mantle {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 50%;
            top: 0;
            z-index: 2;
            transform: translate(-50%);
            background: rgba(0, 0, 0, 0.5);
            border-radius: 10px;

            img {
                position: absolute;
                top: calc(50% - 39px);
                left: calc(50% - 39px);
                width: 78px;
                height: 78px;
            }
        }
    }
}

* {
    box-sizing: border-box;
}

.share-box {
    width: 100%;
    height: 100vh;
    background: #F7F7F7;
    overflow-y: scroll;
    overflow-x: hidden;
    position: relative;

    .share-top {
        width: 100%;
        height: 278px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .base-info {
        width: 694px;
        // height: 148px;
        background: #FFFFFF;
        box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.09);
        border-radius: 16px;
        margin: -24px auto 0;
        position: relative;
        z-index: 1;
        padding: 24px 32px;

        .title {
            font-size: 32px;
            font-weight: 600;
            color: #222222;
        }

        .info {
            margin-top: 20px;
            display: flex;
            align-items: center;

            .info-item {
                display: flex;
                align-items: center;
                margin-right: 32px;

                img {
                    width: 24px;
                    height: 24px;
                    margin-right: 8px;
                }

                span {
                    font-size: 24px;
                    font-weight: 400;
                    color: #AEAEAE;
                }
            }
        }
    }

    .eva-test {
        margin-top: 20px;
        width: 100%;
        background: linear-gradient(180deg, #1D4B9A 0%, #102960 100%);
        padding: 24px 28px;
        font-size: 34px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 44px;

        .after {
            font-size: 26px;
            text-align: right;
            color: rgba(255, 255, 255, 0.6);
        }
    }

    .eva-item {
        width: 694px;
        background: #FFFFFF;
        border-radius: 16px;
        margin: 20px auto 0;
        padding: 32px 28px;

        .top-info {
            display: flex;

            .man-wrap {
                width: 84px;
                position: relative;

                .head-img {
                    width: 80px;
                    height: 80px;
                    background: #f7f7f7;
                    object-fit: cover;
                    border-radius: 50%;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        border-radius: 50%;
                    }
                }

                .name {
                    margin-top: 8px;
                    font-size: 28px;
                    font-weight: 600;
                    white-space: nowrap;
                    color: #444444;
                }

                .name2 {
                    position: absolute;
                    left: 100px;
                    top: 28px;
                    font-size: 28px;
                    font-weight: 600;
                    white-space: nowrap;
                    color: #444444;
                }
            }

            .eva-info {
                padding-left: 20px;

                .tag-wrap {
                    display: flex;
                    align-items: center;

                    .tag {
                        background: rgba(39, 91, 166, 0.09);
                        border-radius: 16px;
                        font-size: 24px;
                        font-weight: 400;
                        color: #275BA6;
                        padding: 0 14px;
                    }

                    .date {
                        margin-left: 12px;
                        font-size: 20px;
                        font-weight: 400;
                        color: #AEAEAE;
                    }
                }

                .test-eva {
                    background: #F7F7F7;
                    border-radius: 12px;
                    font-size: 28px;
                    font-weight: 400;
                    color: #222222;
                    line-height: 40px;
                    margin-top: 18px;
                    padding: 16px 24px;
                }
            }
        }

        .swiper {
            margin-top: 24px;
            width: 100%;
            height: 404px;
            border-radius: 16px;
            overflow: hidden;

            .my-swipe {
                height: 100%;

                .swiper-item {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    position: relative;

                    video {
                        width: 100%;
                        height: 100%;
                        display: block;
                        object-fit: cover;
                    }

                    img {
                        width: 100%;
                        height: 100%;
                        display: block;
                        object-fit: cover;
                    }

                    .play-icon {
                        width: 100px;
                        height: 100px;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }

        .img-wrap {
            //display: flex;
            align-items: center;
            margin-top: 24px;
            overflow-x: scroll;
            overflow-y: hidden;
            display: flex;
            flex-wrap: wrap;
            //flex-wrap: nowrap;
            //align-items: center;


            .img-item {
                width: 200px;
                min-width: 200px;
                height: 200px;
                padding: 5px;
                background: #f7f7f7;
                margin-right: 15px;
                margin-bottom: 15px;
                display: inline-block;
                object-fit: cover;
                border-radius: 16px;
                border: 2px solid transparent;
                position: relative;

                img {
                    width: 100%;
                    height: 100%;
                    display: block;
                    object-fit: cover;
                    border-radius: 16px;
                }

                video {
                    width: 100%;
                    height: 100%;
                    display: block;
                    object-fit: cover;
                    border-radius: 16px;
                }

                //&:nth-child(3n) {
                //    margin: 0;
                //}

                .play-icon {
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }

            .img-item:nth-child(3n) {
                margin-right: 0;
            }

            .img-item-act {
                border: 2px solid #275BA6;
            }
        }


        .video-wrap {
            width: 514px;
            height: 64px;
            background: #F7F7F7;
            margin: 20px 0 0 0;
            background: url(~@/assets/images/share/video.png) no-repeat top/cover;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            span {
                font-size: 28px;
                font-weight: 400;
                color: #275BA6;
            }

            // img {
            //     width: 32px;
            //     height: 32px;
            //     margin: 0 26px 0 16px;
            // }
            .voice-icon {
                margin: 0 26px 0 16px;
                position: relative;
                width: 32px;
                height: 32px;

                img {
                    width: 32px;
                    height: 32px;
                }

                .icon1 {
                    position: absolute;
                    left: 50%;
                    transform: translate(-50%);
                    top: 0;
                    width: 8px;
                    height: 32px;
                    z-index: 2;
                }

                .mengceng {
                    position: absolute;
                    left: 50%;
                    transform: translate(-50%);
                    top: 0;
                    width: 8px;
                    height: 32px;
                    background: #F7F7F7;
                    z-index: 1;
                    animation: title 2s infinite;
                }

                @keyframes title {
                    0% {
                        width: 8px;
                    }

                    40% {
                        width: 30px;
                    }

                    50% {
                        width: 32px;
                    }

                    90% {
                        width: 10px;
                    }

                    100% {
                        width: 8px;
                    }
                }
            }
        }

        .line-wrap {
            border-bottom: 1px dashed rgba(242, 242, 242, 1);
            width: 120%;
            transform: translateX(-39px);
            margin-top: 28px;
            margin-bottom: 28px;
        }

        .acceptance {
            margin-top: 28px;
            width: 100%;
            height: 212px;
            background: rgba(39, 91, 166, 0.09);
            border-radius: 12px;
            padding: 20px;

            .title-wrap {
                display: flex;
                align-items: center;
                justify-content: space-between;

                .text {
                    font-size: 28px;
                    font-weight: 400;
                    color: #275BA6;
                }

                img {
                    width: 40px;
                    height: 40px;
                }
            }

            .img-box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 20px;

                .img-wrap {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 480px;
                    margin: 0;

                    .img-item2 {
                        width: 108px;
                        height: 108px;
                        background: #f7f7f7;
                        border-radius: 0;
                        object-fit: cover;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                }

                .ac-icon {
                    flex: 1;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;

                    img {
                        width: 104px;
                        height: 96px;
                    }
                }
            }
        }
    }

    .topic-wrap {
        padding: 40px 28px 0 28px;


        .topic-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 40px;

            .line {
                width: 246px;
                height: 2px;
                border: 2px solid rgba(18, 90, 172, 0.27);
            }

            .title-topic {
                font-size: 32px;
                font-weight: 500;
                color: #275BA6;
            }
        }

        .topic-item {
            .item-title {
                padding-left: 12px;
                font-size: 28px;
                font-weight: 600;
                color: #275BA6;
                position: relative;

                &:before {
                    position: absolute;
                    content: "";
                    width: 4px;
                    height: 32px;
                    background: #275BA6;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 0;
                }
            }

            .d-wrap {
                margin-bottom: 48px;
                margin-top: 30px;
                width: 100%;
                height: 194px;
                background: #EBF0F7;
                border-radius: 12px;
                display: flex;
                align-items: center;
                justify-content: space-around;

                .d-img {
                    width: 380px;
                    height: 160px;
                    object-fit: cover;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }

                .btn {
                    display: flex;
                    align-items: center;
                    width: 194px;
                    height: 56px;
                    background: rgba(39, 91, 166, 0.09);
                    border-radius: 28px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    span {
                        font-size: 28px;
                        font-weight: 400;
                        color: #275BA6;
                    }

                    img {
                        width: 40px;
                        height: 40px;
                    }
                }
            }

            .team-wrap {
                .team-item {
                    margin-top: 20px;
                    width: 100%;
                    padding: 30px 20px;
                    // height: 172px;
                    background: #FFFFFF;
                    border-radius: 12px;
                    display: flex;

                    .head-img-team {
                        width: 112px;
                        height: 112px;
                        // background: rgba(39, 91, 166, 1);
                        border-radius: 50%;
                        border: 1px solid #f7f7f7;
                        object-fit: cover;

                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            border-radius: 50%;
                        }
                    }

                    .info-box-team {
                        padding-left: 16px;
                        flex: 1;

                        .top-info {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;

                            .info-it {
                                font-size: 24px;
                                font-weight: 400;
                                color: #222222;
                            }

                            .name {
                                font-size: 28px;
                                font-weight: 600;
                                color: #222222;
                            }

                            .info-right {
                                display: flex;
                                width: 400px;
                                justify-content: space-between;

                                .info-it-num {
                                    text-align: right;
                                }
                            }
                        }

                        .b-info {
                            margin-top: 22px;
                            background: rgba(39, 91, 166, 0.09);
                            border-radius: 23px;
                            font-size: 20px;
                            font-weight: 400;
                            color: #275BA6;
                            line-height: 32px;
                            padding: 6px 12px;
                            display: inline-block;
                        }
                    }
                }
            }
        }

        .product-wrap {
            width: 100%;
            height: 152px;
            background: rgba(235, 240, 247, 1);
            border-radius: 12px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 24px;
            position: relative;
            overflow: hidden;

            .left-wrap {
                display: flex;
                align-items: center;

                img {
                    width: 154px;
                    height: 100px;
                }

                div {
                    margin-left: 24px;
                    font-size: 28px;
                    font-weight: 400;
                    color: #125AAC;
                    line-height: 40px;
                }
            }

            .right {
                img {
                    width: 40px;
                    height: 40px;
                }
            }

            .lj-wrap {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 32px;
                background: rgba(39, 91, 166, 0.09);
                position: absolute;
                top: 0;
                right: 0;
                padding: 4px 10px;

                img {
                    width: 24px;
                    height: 24px;
                    margin-right: 4px;
                }

                span {
                    font-size: 20px;
                    font-weight: 400;
                    color: #275BA6;
                }
            }
        }

        .more-wrap {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;

            .more-item {
                width: 338px;
                height: 104px;
                background: #EBF0F7;
                border-radius: 12px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 24px;

                .more-left {
                    display: flex;
                    align-items: center;

                    img {
                        width: 48px;
                        height: 48px;
                        margin-right: 8px;
                    }

                    span {
                        font-size: 28px;
                        font-weight: 400;
                        color: #125AAC;
                    }
                }

                img {
                    width: 40px;
                    height: 40px;
                }
            }
        }
    }

    .topic-wrap-m {
        margin-bottom: 72px;
    }

    .people-wrap {
        //margin-top: 72px;
        width: 100%;
        height: 180px;
        background: #E8E8E8;
        border-radius: 16px 16px 0px 0px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 74px 0 60px;
        position: sticky;
        left: 0;
        bottom: 0;
        z-index: 999;


        .left {
            display: flex;
            align-items: center;

            .head {
                width: 100px;
                height: 100px;
                border-radius: 50%;
                background: #ffffff;
                object-fit: cover;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 50%;
                }
            }

            .name {
                font-size: 28px;
                font-weight: 600;
                color: #222222;
                margin-left: 32px;
            }

            .tag {
                font-size: 20px;
                font-weight: 400;
                color: #222222;
                margin-left: 24px;
            }
        }

        .right {
            width: 140px;
            height: 140px;
            background: #f7f7f7;
            object-fit: cover;
            position: relative;
            z-index: 10;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                //border-radius: 50%;
            }

            .mask_img {
                width: 300%;
                min-width: 300%;
                height: 300%;
                object-fit: cover;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
                opacity: 0;
            }
        }
    }

    .people-wrap-m {
        position: relative;
    }

    .page-b {
        width: 100%;
        height: 264px;
        background: linear-gradient(180deg, #1D4B9A 0%, #102960 100%);
        display: flex;
        align-items: center;
        padding: 0 20px 0 60px;
        justify-content: space-between;

        .b-left {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 364px;

            .txt {
                width: 364px;
                font-size: 30px;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 40px;
                text-align: justify;
                text-align-last: justify;
                letter-spacing: 0;
            }


            img {
                width: 364px;
                margin-bottom: 24px;
                height: 44px;
            }
        }

        .b-right {
            img {
                width: 248px;
                height: 160px;
            }
        }
    }
}


.code_box {
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    width: 100vw;
    height: 100vh;
    z-index: 9999;
    display: flex;
    align-items: center;

    .code_plan {
        width: 100vw;
        height: 100vw;

        img {
            width: 100%;
            height: 100%;
            display: block;
        }
    }
}

</style>
